import { hardReplace } from './navigation';

/** Anything with an HTTP status; IDM error shapes all satisfy this. */
type WithStatus = { status?: number };

const SERVER_ERROR = 500;

/**
 * Sends the user to the error page on a 500. Other statuses are left to the
 * caller, which knows how to present them in context.
 */
export function apiErrorHandler(error: unknown, lang = 'en') {
	const status = (error as WithStatus | null)?.status;

	if (status === SERVER_ERROR) {
		hardReplace(`/${lang}/error/500`);
	}
}
